import { Engine } from '@babylonjs/core/Engines/engine';
import { Scene } from '@babylonjs/core/scene';
import { Color3 } from '@babylonjs/core/Maths/math';
// import '@babylonjs/core/Materials/Textures/Loaders/ktxTextureLoader';
//! Needed I don't know WHY
import '@babylonjs/core/Materials/Textures/colorGradingTexture';

import { Observable } from '../Tools/observable';

export enum SystemEvent {
    Resize, // SystemResponsive
    MouseTrailTexture // MouseTrail Texture effect
}

export class System extends Observable<SystemEvent, number> {
    /**
    * Max Hardware scaling of BabylonJS Engine
    */
    protected maxScaling = 1;

    /**
    * BabylonJS Engine
    */
    public engine: Engine;

    /**
     * BabylonJS Scene
     */
    public scene: Scene;

    /**
     * Canvas used to draw the 3D scene
     */
    public canvas: HTMLCanvasElement;

    /**
     * Creates a new System
     * @param canvas Element where the scene will be drawn
     */
    constructor(canvas: HTMLCanvasElement) {
        super('System');
        // if (!Engine.isSupported()) throw 'WebGL not supported';
        this.canvas = canvas;
        // For now keep false as the last argument of the engine,
        // We don't want the canvas to adapt to screen ratio as it slow down too much the scene
        // preserveDrawingBuffer and stencil needed for screenshot
        // premultipliedAlpha needed for .HDR to .ENV transformation

        const engineOption = {
            limitDeviceRatio: this.maxScaling,
            preserveDrawingBuffer: true,
            stencil: true,
            premultipliedAlpha: false,
            //* If need to test WebGL 1
            // disableWebGL2Support: true
        };
        this.engine = new Engine(this.canvas, false, engineOption);
        // NOTE to avoid request for manifest files because it can block loading on safari
        this.engine.enableOfflineSupport = false;
        this.engine.setHardwareScalingLevel(0.5);
        // this.engine.setHardwareScalingLevel(0.25);
        this.buildScene();
        this.optimize();
    }

    /**
    * @ignore
    */
    private buildScene() {
        this.scene = new Scene(this.engine);
        this.scene.shadowsEnabled = false;
        this.scene.ambientColor = new Color3(1, 1, 1);
        this.scene.skipPointerMovePicking = true;
        // Test to fix shader alpha issue
        // this.scene.useOrderIndependentTransparency = true;
        // Avoid automatic pick and improve performance
        // Can't use it now as it breaks GUI events
        // this.scene.detachControl();
    }

    /**
    * Tell if system currently rendering scene
    */
    protected rendering = false;

    /**
    * Tell if scene needs to be render
    */
    public launched = false;

    /**
     * Allow to launch scene rendering (when everything is loaded for instance)
     */

    public launchRender() {
        //! Waiting for ready creates bug with Ribbon
        this.launched = true;
        this.notify(SystemEvent.Resize, 0);
    }

    public checkSceneReady(callback: () => void) {
        // Make sure scene is ready
        this.scene.executeWhenReady(() => {
        //! scene.render will call executeWhenReady again creating a callbacck loop
        //! setTimeout prevent that
            setTimeout(() => {
                this.scene.render();
                callback();
            }, 100);
        });
    }

    /**
     * Stop scene rendering
     */
    public stopRender() {
        this.launched = false;
        this.pauseRender();
    }

    /**
     * @ignore
     */
    public pauseRender() {
        if (!this.rendering) return;
        // console.log('stop');
        this.rendering = false;
        this.engine.stopRenderLoop();
    }

    /**
     * @ignore
     */
    public startRender() {
        if (this.rendering || !this.launched) return;
        // console.log('start');
        this.rendering = true;
        this.engine.resize();
        this.forceRender();
    }

    public isRendering(): boolean {
        return this.rendering;
    }

    public forceRender() {
        this.engine.stopRenderLoop();
        if (this.limitFPS) {
            this.engine.runRenderLoop(() => {
                if (this.limitSwitch) this.scene.render();
                this.limitSwitch = !this.limitSwitch;
            });
        } else {
            this.engine.runRenderLoop(() => {
                this.scene.render();
            });
        }
    }

    /**
     * Optimize scene to make rendering faster
     * https://doc.babylonjs.com/how_to/optimizing_your_scene#reducing-shaders-overhead
     */

    public optimize() {
        this.scene.autoClear = false; // Color buffer
        this.scene.autoClearDepthAndStencil = false; // Depth and stencil, obviously
        this.scene.blockMaterialDirtyMechanism = true;
        // this.scene.clearCachedVertexData();
        // this.scene.cleanCachedTextureBuffer();
        // let activeTest = 0;
        // this.scene.registerBeforeRender(() => {
        //     activeTest++;
        //     this.scene.freezeActiveMeshes();
        //     if (activeTest > 30) {
        //         activeTest = 0;
        //         this.scene.unfreezeActiveMeshes();
        //     }
        // });
        // this.scene.setRenderingAutoClearDepthStencil(
        //     renderingGroupIdx,
        //     autoClear,
        //     depth,
        //     stencil
        // );
    }

    public checkActiveMeshes() {
        this.scene.unfreezeActiveMeshes();
        this.scene.freezeActiveMeshes();
    }

    protected limitFPS = false;

    // Keep first value as true so that render function is called straight away
    // Otherwise you could have a flash
    protected limitSwitch = true;

    public setLimitFPS(limitFPS: boolean) {
        if (limitFPS === this.limitFPS) return;
        this.limitFPS = limitFPS;
    }
}
